/**
 * 공고 상태 — 화면마다 다른 말을 쓰던 것을 한곳으로 모은다.
 *
 * 같은 상태를 두고 공개 목록은 'OPEN', 어드민 목록은 'open', 어드민 필터는 'active'를
 * 쓰고 있었고, 각 화면이 자기 표를 따로 들고 있었다. 표에 없는 철자가 오면
 * 한국어 대신 'open' 같은 원문이 그대로 뱃지에 찍히고, 목록 탭은 아무것도 걸러내지
 * 못했다 — 공고는 멀쩡한데 '모집중' 탭이 비어 보이는 증상이 이것이다.
 */
const STATUSES = {
  OPEN:          { label: '모집중',   cls: 'ag-badge--success' },
  PLANNING:      { label: '기획중',   cls: 'ag-badge--warn' },
  IN_PRODUCTION: { label: '제작중',   cls: 'ag-badge--warn' },
  CLOSED:        { label: '마감',     cls: 'ag-badge--danger' },
  DRAFT:         { label: '임시저장', cls: 'ag-badge--warn' },
};

/** 같은 상태를 가리키는 다른 철자들 */
const ALIASES = {
  ACTIVE: 'OPEN',
  RECRUITING: 'OPEN',
  ENDED: 'CLOSED',
  CLOSE: 'CLOSED',
  TEMP: 'DRAFT',
};

/**
 * 어떤 철자로 와도 하나의 키로 모은다. 대소문자를 가리지 않는다.
 * @returns {string|null} 아는 상태가 아니면 null
 */
export function postingStatusKey(raw) {
  if (typeof raw !== 'string') return null;
  const key = raw.trim().toUpperCase();
  if (STATUSES[key]) return key;
  return ALIASES[key] ?? null;
}

/** 화면에 적을 한국어. 모르는 값은 원문을 그대로 돌려준다 — 빈칸보다 낫다. */
export function postingStatusLabel(raw) {
  const key = postingStatusKey(raw);
  return key ? STATUSES[key].label : (raw ?? '—');
}

/** 어드민 뱃지용 — 라벨과 색을 함께 */
export function postingStatusMeta(raw) {
  const key = postingStatusKey(raw);
  if (!key) return { key: null, label: raw ?? '—', cls: 'ag-badge--gray' };
  return { key, ...STATUSES[key] };
}

/** 모집이 진행 중인 상태인가 — 기획·제작 중인 공고도 지원을 받는다 */
export function isOpenStatus(raw) {
  const key = postingStatusKey(raw);
  return key === 'OPEN' || key === 'PLANNING' || key === 'IN_PRODUCTION';
}
